var _circle, _path, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#183883"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4468 18L19.9787 26.0603M19.9787 26.0603H29.7447M19.9787 26.0603L20.7021 29.3577C20.7021 29.3577 19.4586 33.6633 18.8936 35.9525M29.7447 35.9525L27.5745 26.0603M28.2422 29.3577C28.2422 29.3577 23.3303 29.3577 20.6465 29.3577M16 35.2198C18.5319 36.5632 25.4766 38.4439 33 35.2198",
    stroke: "#183883",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 18.5,
    r: 5,
    stroke: "#183883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9489 17.6868L33.8359 18.0618H31.1555L31.2663 17.6868H33.9489ZM32.8643 21L31.1896 19.0334L31.1854 18.7585H31.9183C32.1399 18.7585 32.3288 18.7266 32.4851 18.6626C32.6413 18.5973 32.7607 18.5007 32.843 18.3729C32.9268 18.245 32.9688 18.0866 32.9688 17.8977C32.9688 17.6193 32.8814 17.4006 32.7067 17.2415C32.5334 17.081 32.2848 17.0007 31.9609 17.0007H31.1555L31.2663 16.6364H31.9609C32.2734 16.6364 32.5348 16.6903 32.745 16.7983C32.9567 16.9062 33.1158 17.0554 33.2223 17.2457C33.3303 17.4347 33.3842 17.652 33.3842 17.8977C33.3842 18.1278 33.3324 18.3352 33.2287 18.5199C33.1264 18.7031 32.968 18.8487 32.7536 18.9567C32.5405 19.0632 32.2685 19.1165 31.9375 19.1165H31.7841L33.3608 20.968V21H32.8643ZM33.9638 16.6364L33.853 17.0114L31.5945 17.0007L31.6967 16.6364H33.9638Z",
    fill: "#183883"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApy);
export default __webpack_public_path__ + "static/media/APY.1f5100b46f5865d8f685861fd4f87d31.svg";
export { ForwardRef as ReactComponent };